

export const createModelAvailability = `mutation($input: CreateModelAvailabilityRequest!) {
   createModelAvailability(input: $input) {
      pkId
      message
      version
      region
      productGroup
      productFamily
      country
      businessModel
      startDate
      endDate
      hStartDate
      hEndDate
      productDesc
      countryDesc
      comments
      status
      apRegion
      euRegion
      naRegion
      laRegion
      whoChanged
      createDate
      lastModifiedDate
    }
  }`;



export const GetProductLine = `query($filter: GetProductLineRequest!) {
    ocplcProductLine(filter: $filter) {
        productLine {
            id
            name
        }
    }
}`;

export const createMaterialAvailability = `mutation createMaterial($input: CreateMaterialWWRequest!) {
  createMaterialAvailability(input: $input) {
    pkId
    message
    version
    region
    country
    countryDesc
    businessGroup
    businessModel
    productGroup
    productFamily
    material
    materialDesc
    choiceId
    localization
    startDate
    endDate
    autoStart
    autoEnd
    hStartDate
    hEndDate
    comments
    apRegion
    euRegion
    naRegion
    laRegion
    status
    regionLock
    logicalLock
    whoChanged
    createDate
    lastModifiedDate
    keyOrder
  }
}`;    

export const copyRegionForMaterialAvailability = `mutation CreateMaterialAvailability($input: EditMaterialAvailabilityRequest!) {
  createRegionalMaterialAvailability(input: $input) {
    status
    message
    pkId
    message
    status
    startDate
    endDate
    createDate
    lastModifiedDate
  }
}`;

export const getOcplcChoices = `query($filter: OcplcChoiceIdRequest!) {
  ocplcChoice(filter:  $filter) {
    choices {
      value
      text
    }
  }
}`; 

//this Query is used to ADD, EDIT and Copy Default Localization record
export const createDefaultLoc = `mutation CreateDefaultLocEntry($input: CreateDefaultLocRequest!) {
  createDefaultLoc(input: $input) {
    message
    response
    pkId
    version
    region
    country
    countryDesc
    productFamily
    productDesc
    productGroup
    feature
    featureValue
    locFeature
    locFeatureValue
    status
    comments
    whoChanged
    lastModifiedDate
    createDate
  }
}`;

//this Query is used to ADD/UPDATE/COPY TOF Program Management record
export const createTofProgramsManagement = `mutation CreateTOFProgramManagement($input: CreateTOFProgramManagementRequest!) {
  createTofProgramsManagement(input: $input) {
    pkId
    version
    region
    productFamily
    productGroup
    parameterKey
    parameterValue
    parameterText
    comments
    status
    createDate
    whoChanged
    lastModifiedDate
    message
    response
  }
}`;

export const createLocalizationChoiceMapping = `mutation CreateLocalizationChoiceMapping($input: CreateTOFProgramManagementRequest!) {
  createLocalizationChoiceMapping(input: $input) {
    pkId
    version
    region
    productFamily
    productGroup
    parameterKey
    parameterValue
    parameterText
    comments
    status
    createDate
    whoChanged
    lastModifiedDate
    message
    response
  }
}`

export const createLocalizationMapping = `mutation CreateLocalizationMapping($input: CreateTOFProgramManagementRequest!) {
  createLocalizationMapping(input: $input) {
    pkId
    version
    region
    productFamily
    productGroup
    parameterKey
    parameterValue
    parameterText
    comments
    status
    createDate
    whoChanged
    lastModifiedDate
    message
    response
  }
}`
